class AltText {
  constructor(config = {}) {
    const {
      altTextSelector,
    } = config;

    this.altTextSelector = document.querySelectorAll(altTextSelector);
    this.altTextSelectorArray = Array.prototype.slice.call(this.altTextSelector);
    if (this.altTextSelectorArray && this.altTextSelector.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
      this.altTextSelectorArray.forEach(item => {
        if(item.querySelectorAll('span')[1]){
          let spanWithText = item.querySelectorAll('span')[1];
          let currentText = spanWithText.innerText;
          let currentImage = item.previousElementSibling;
          currentImage.setAttribute("alt", currentText);
        }
      });
  }
}

export default AltText;
